module.exports = __webpack_public_path__ + "static/alex-profile-5c1bbc074bc8a6adb3598ed908865ea9.jpeg";